import { useContext } from 'react'
import { toast } from 'react-toastify'
import { AuthContext, useTranslator } from 'ufinet-web-functions'
import { HttpClientsRepository } from 'src/modules/clients/infrastructure/HttpClientsRepository'
import { Client } from 'src/modules/clients/domain/Client'

export const useClientValidation = () => {
	const authData = useContext(AuthContext)
	const translate = useTranslator()
	const clientRepository = HttpClientsRepository(authData)

	const validateClientBeforeFindAll = async (customersId: string[]): Promise<boolean> => {               
		try {			
			if (!customersId || customersId.length === 0) {
				return false
			}
			const clients: Client[] = await clientRepository.findAll()
            
			if (!clients || clients.length === 0) {
				return false
			}
			return true
		} catch (error) {
			console.error('Error validating clients:', error)
			toast.error(translate('TICKET.FILTER.CLIENT_VALIDATION_ERROR'))
			return false
		}
	}
	const shouldProceedWithFindAll = async (isInternal: boolean, customersId: string[]): Promise<boolean> => {		
		if (isInternal) {
			return true
		}		
		return await validateClientBeforeFindAll(customersId)
	}

	return {
		validateClientBeforeFindAll,
		shouldProceedWithFindAll,
	}
}
